// SPECTACLE_CLI_THEME_START
const theme = {
    fonts: {
        header: "'Source Code Pro', monospace",
        text: "'Raleway', sans-serif"
    },
    colors: {
        primary: '#FF0080',
        secondary: '#fff',
        tertiary: '#0E2133',
        quaternary: '#FF0080',
    },
    fontSizes: {
        header: '64px',
        paragraph: '28px',
        text: '28px'
    },
    space: [0, 4, 8, 16, 32, 64],
    size: {
        maxCodePaneHeight: 450
    }
  };
  // SPECTACLE_CLI_THEME_END

export default theme;
